// Kept apart from the network hooks so Datadog setup can filter these URLs out
// without pulling in the CCP store. `region` and `subdomain` are typed as
// undefined because callers (e.g. Datadog) may not have config fully loaded.

interface NetworkProbeUrls {
  primary: string
  fallback: string
}

/**
 * The ${subdomain}.telemetry.connect ping answers 200 in one round trip.
 * The subdomain is copied from AWS's Endpoint Test Utility, which pings one
 * per region. It's covered by the `*.telemetry.connect.{region}` entry on the
 * CCP's required allowlist, so any network that can run the CCP can reach it.
 * Connect's regional API is the fallback if that host ever disappears:
 * it works anywhere the CCP does, but answers 403, which Chrome logs
 * as a console error on every probe.
 * @param region
 * @param subdomain
 */
export function getNetworkProbeUrls(
  region: string | undefined,
  subdomain: string | undefined
): NetworkProbeUrls | null {
  if (!region || !subdomain) return null
  return {
    primary: `https://${subdomain}.telemetry.connect.${region}.amazonaws.com/ping`,
    fallback: `https://connect.${region}.amazonaws.com/`,
  }
}

/**
 * @param url
 * @param region
 * @param subdomain
 */
export function isNetworkProbeUrl(
  url: string | undefined,
  region: string | undefined,
  subdomain: string | undefined
): boolean {
  const urls = getNetworkProbeUrls(region, subdomain)
  return !!url && !!urls && (url === urls.primary || url === urls.fallback)
}
